import Helmet from 'react-helmet';

export interface PageTitleProps {
  title?: string;
}

const PageTitle = ({ title }: PageTitleProps) => {
  const defaultTitle = 'Numerator Insights';
  return (
    <Helmet defer={false}>
      <title>{title || defaultTitle}</title>
    </Helmet>
  );
};

export default PageTitle;
